import React, { useState } from 'react';
import styled from '@emotion/styled';
import { createPhoneURI } from 'hooks/useDisplayPhone';
import { ContactButton, contactButtonDefaultProps } from '../styled';
import PhoneIcon from 'assets/svg/phone-1-5.svg';
import withEvents from 'analytics/withEvents';


export const Anchor = styled(ContactButton.withComponent('a'))`
  text-decoration: none;
  > svg {
    width: 16px;
    height: 16px;
  }
`;
Anchor.defaultProps = contactButtonDefaultProps;

interface PhoneAnchorProps {
  phone: string;
  label: string;
  dataAuto?: string;
  onPhoneCall?: () => void;
  onPhoneShown?: () => void;
  officeId?: string;
  agentId?: string;
  className?: string;
  fullWidth?: boolean;
}

export const PhoneAnchor: React.FC<PhoneAnchorProps> = props => {
  const { label, phone, dataAuto, className, onPhoneCall, onPhoneShown, fullWidth = true } = props;
  const [ isPhoneVisible, setPhoneVisible ] = useState(false);
  const href = createPhoneURI(phone);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (isPhoneVisible) {
      if (onPhoneCall) onPhoneCall();
    }
    else {
      e.preventDefault();
      setPhoneVisible(true);
      if (onPhoneShown) onPhoneShown();
    }
  };

  return (
    <Anchor data-auto={dataAuto} className={className} onClick={handleClick} href={href} fullWidth={fullWidth}>
      {isPhoneVisible ? (
        <>
          <PhoneIcon />
          {phone}
        </>
      ) : label}
    </Anchor>
  );
};

export default withEvents<PhoneAnchorProps>((sendEvent, props) => ({
  onPhoneCall() {
    sendEvent('user_contact_me_call_submit', 'user', {
      rtbData: {
        phone: props.phone,
      },
    });
  },
  onPhoneShown() {
    sendEvent('user_contact_me_phone_expose', 'user', {
      event: {
        agent_details: {
          ...(props.officeId ? { office_id: props.officeId } : null),
          ...(props.agentId ? { id: props.agentId } : null),
        },
      },
    });
  },
}))(PhoneAnchor);
